/******/ // The require scope
/******/ var __webpack_require__ = {};
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   W: () => (/* binding */ WAZE_SEMI_CATEGORIES),
/* harmony export */   z: () => (/* binding */ WAZE_SEMI_CATEGORY_OTHER_ID)
/* harmony export */ });
const WAZE_SEMI_CATEGORY_OTHER_ID = "other";
// In order to update the semi-categories list, a new object should be added to the array with the following properties:
// * id: the unique translation key with the full path `waze.semi_categories.names.${id}`, that is also used
//   as an identifier for the semi-category. Translation should be added to
//   "/src/plugin/config/locales/client.en.yml" file;
// * image: the category image. The image should be added to "/src/plugin/public/images/my-image.png" and
//   referred as "plugins/waze-semi-category/images/my-image.png" in the object.
const WAZE_SEMI_CATEGORIES = Object.freeze([
    {
        id: "editors_official_announcements",
        image: "plugins/waze-semi-category/images/official_announcements.svg",
        color: "E1C7FF",
    },
    {
        id: "community",
        image: "plugins/waze-semi-category/images/communities_hub.png",
    },
    {
        id: "waze_map_editor",
        image: "plugins/waze-semi-category/images/waze_map_editor.svg",
        color: "FDEC7B",
    },
    {
        id: "editors_community",
        image: "plugins/waze-semi-category/images/editors_community.svg",
        color: "FDEC7B",
    },
    {
        id: "get_help_here",
        image: "plugins/waze-semi-category/images/get_help_here.svg",
        color: "FF8F8F",
    },
    {
        id: "waze_for_cities",
        image: "plugins/waze-semi-category/images/waze_for_cities.svg",
        color: "D5ACFF",
    },
    {
        id: "editors_knowledge_and_learning",
        image: "plugins/waze-semi-category/images/knowledge_and_learning.png",
        color: "E6CCFF",
    },
    {
        id: "apac",
        image: "plugins/waze-semi-category/images/global.svg",
        color: "FFCCCC",
    },
    {
        id: "emea",
        image: "plugins/waze-semi-category/images/global.svg",
        color: "FFDEBD",
    },
    {
        id: "latam",
        image: "plugins/waze-semi-category/images/global.svg",
        color: "FFF59D",
    },
    {
        id: "na",
        image: "plugins/waze-semi-category/images/global.svg",
        color: "E5CCFF",
    },
    { id: "staff", image: "plugins/waze-semi-category/images/forums.svg" },
    {
        id: "mentoring",
        image: "plugins/waze-semi-category/images/forums.svg",
    },
    {
        id: "forum_moderation",
        image: "plugins/waze-semi-category/images/forums.svg",
    },
    {
        id: "off_topic",
        image: "plugins/waze-semi-category/images/forums.svg",
    },
    {
        id: "routing",
        image: "plugins/waze-semi-category/images/forums.svg",
    },
    {
        id: "localization",
        image: "plugins/waze-semi-category/images/forums.svg",
    },
    {
        id: "wazeopedia",
        image: "plugins/waze-semi-category/images/forums.svg",
    },
    {
        id: "brazil",
        image: "plugins/waze-semi-category/images/global.svg",
        color: "87F6C2",
    },
    {
        id: "waze_app",
        image: "plugins/waze-semi-category/images/forums.svg",
    },
    {
        id: "official_announcements",
        image: "plugins/waze-semi-category/images/official_announcements.svg",
    },
    {
        id: "leadership",
        image: "plugins/waze-semi-category/images/leadership.svg",
        color: "87F6C2",
    },
    {
        id: "community_leadership",
        image: "plugins/waze-semi-category/images/leadership.svg",
        color: "87F6C2",
    },
    {
        id: WAZE_SEMI_CATEGORY_OTHER_ID,
        image: "plugins/waze-semi-category/images/forums.svg",
        color: "FFCC99",
    },
].map((semiCategory, idx) => {
    return Object.freeze(semiCategory);
}));

const __webpack_exports__WAZE_SEMI_CATEGORIES = __webpack_exports__.W;
const __webpack_exports__WAZE_SEMI_CATEGORY_OTHER_ID = __webpack_exports__.z;
export { __webpack_exports__WAZE_SEMI_CATEGORIES as WAZE_SEMI_CATEGORIES, __webpack_exports__WAZE_SEMI_CATEGORY_OTHER_ID as WAZE_SEMI_CATEGORY_OTHER_ID };
